import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';

const { routes } = AppConfig;

// unlike nonProductionGuard (which checks `environment.production`, true on both stage and prod),
// this guard allows local, dev, qa AND stage, and only blocks prod
export const preProductionGuard: () => boolean | UrlTree = () => {
  const router = inject(Router);
  const environment = inject(ENVIRONMENT_PROVIDER);

  if (environment.name === 'prod') {
    return router.parseUrl('/' + routes.error404);
  }

  return true;
};
